// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-form-group{margin-bottom:1rem}.v-form-group .v-input__label,.v-form-group ::v-deep .v-form-control__label{margin-top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
